/**
 * Web access check (mobile-only billing, FODMAPSnap / KidneyPal pattern).
 *
 * Vore has no web checkout — Premium is bought in the mobile app (RevenueCat)
 * or through the Paddle funnel (which sets the same `userSettings.premium`
 * mirror server-side). The mobile app gates every feature on that mirror, so
 * the web does too. `syncPremiumStatus` additionally verifies the LIVE
 * RevenueCat `Premium` entitlement server-side and flips a stale mirror to
 * true (never false) — the "just bought it on my phone" refresh path.
 */
import { httpsCallable } from 'firebase/functions'
import { doc, getDoc } from 'firebase/firestore'
import { auth, db, functions } from '@/lib/firebase'

interface SyncPremiumStatusResponse {
  isPremium: boolean | null
  status?: 'verified' | 'unverified'
}

export async function fetchWebAccess(): Promise<boolean> {
  const uid = auth.currentUser?.uid
  if (!uid) return false
  try {
    const fn = httpsCallable<{ isPremiumClient: boolean }, SyncPremiumStatusResponse>(functions, 'syncPremiumStatus')
    const res = (await fn({ isPremiumClient: false })).data
    if (res && typeof res.isPremium === 'boolean') return res.isPremium
  } catch {
    /* function unavailable / RevenueCat unreachable → fall back to the Firestore mirror below */
  }
  const snap = await getDoc(doc(db, 'userSettings', uid))
  return snap.exists() && snap.data()?.premium === true
}
